<!-- Start from level two since we do not care about frontpage and root page -->
<ng-container
    *ngTemplateOutlet="navigationTemplate; context: { $implicit: pageViewModel?.children, level: 2 }"
></ng-container>
<ng-template #navigationTemplate let-navigationChildren let-level="level">
    <ul
        *ngFor="let child of navigationChildren"
        [ngClass]="{ 'active-list': breadCrumbs && breadCrumbs[level] && breadCrumbs[level].url === child.url }"
    >
        <li class="list-item">
            <a class="link" [ngClass]="{ 'active-link': child.key === activeId }" [routerLink]="child.url">
                {{ child.name }}
            </a>
            <ng-container *ngIf="child.children">
                <ng-container
                    *ngTemplateOutlet="navigationTemplate; context: { $implicit: child.children, level: level + 1 }"
                >
                </ng-container>
            </ng-container>
        </li>
    </ul>
</ng-template>
